// Data constants extracted from features.jsx during the Phase 5 split.

export const MUSCLE_MAP={
  // Chest
  bench:{primary:["chest"],secondary:["triceps","front_delts"]},
  incbench:{primary:["chest"],secondary:["triceps","front_delts"]},
  decbench:{primary:["chest"],secondary:["triceps"]},
  dbbench:{primary:["chest"],secondary:["triceps","front_delts"]},
  dbincbench:{primary:["chest"],secondary:["triceps","front_delts"]},
  flye:{primary:["chest"],secondary:[]},
  dbflye:{primary:["chest"],secondary:[]},
  dip:{primary:["chest"],secondary:["triceps","front_delts"]},
  pushup:{primary:["chest"],secondary:["triceps","front_delts"]},
  machpress:{primary:["chest"],secondary:["triceps"]},
  pecfly:{primary:["chest"],secondary:[]},
  svbench:{primary:["chest"],secondary:["triceps"]},
  closegrip:{primary:["triceps"],secondary:["chest"]},
  // Back
  deadlift:{primary:["back","hamstrings"],secondary:["glutes","core"]},
  row:{primary:["back"],secondary:["biceps"]},
  pullup:{primary:["back"],secondary:["biceps"]},
  latpull:{primary:["back"],secondary:["biceps"]},
  chinup:{primary:["back","biceps"],secondary:[]},
  cablerow:{primary:["back"],secondary:["biceps"]},
  dbrow:{primary:["back"],secondary:["biceps"]},
  tbarrow:{primary:["back"],secondary:["biceps"]},
  pendlay:{primary:["back"],secondary:["biceps"]},
  sumo:{primary:["back","glutes"],secondary:["hamstrings","quads"]},
  rdl:{primary:["hamstrings"],secondary:["back","glutes"]},
  hyperext:{primary:["back"],secondary:["hamstrings","glutes"]},
  straightarm:{primary:["back"],secondary:[]},
  meadows:{primary:["back"],secondary:["biceps"]},
  // Legs
  squat:{primary:["quads"],secondary:["glutes","hamstrings","core"]},
  legpress:{primary:["quads"],secondary:["glutes"]},
  lunge:{primary:["quads"],secondary:["glutes","hamstrings"]},
  frontsquat:{primary:["quads"],secondary:["core","glutes"]},
  bss:{primary:["quads"],secondary:["glutes"]},
  goblet:{primary:["quads"],secondary:["glutes","core"]},
  legext:{primary:["quads"],secondary:[]},
  hamcurl:{primary:["hamstrings"],secondary:[]},
  calfraise:{primary:["calves"],secondary:[]},
  hacksquat:{primary:["quads"],secondary:["glutes"]},
  stepup:{primary:["quads"],secondary:["glutes"]},
  hipthrust:{primary:["glutes"],secondary:["hamstrings"]},
  legcurl:{primary:["hamstrings"],secondary:[]},
  sldl:{primary:["hamstrings"],secondary:["back","glutes"]},
  sissy:{primary:["quads"],secondary:[]},
  // Shoulders
  ohp:{primary:["front_delts"],secondary:["triceps"]},
  dbohp:{primary:["front_delts"],secondary:["triceps"]},
  lateralraise:{primary:["side_delts"],secondary:[]},
  facepull:{primary:["rear_delts"],secondary:["back"]},
  shrug:{primary:["traps"],secondary:[]},
  reardelt:{primary:["rear_delts"],secondary:[]},
  arnoldpress:{primary:["front_delts","side_delts"],secondary:["triceps"]},
  uprow:{primary:["side_delts","traps"],secondary:[]},
  cablateral:{primary:["side_delts"],secondary:[]},
  landmine:{primary:["front_delts"],secondary:["triceps","core"]},
  dbshrug:{primary:["traps"],secondary:[]},
  frontraise:{primary:["front_delts"],secondary:[]},
  // Arms
  curl:{primary:["biceps"],secondary:[]},
  tricep:{primary:["triceps"],secondary:[]},
  hammercurl:{primary:["biceps"],secondary:[]},
  preacher:{primary:["biceps"],secondary:[]},
  skullcrusher:{primary:["triceps"],secondary:[]},
  ohtriext:{primary:["triceps"],secondary:[]},
  concurl:{primary:["biceps"],secondary:[]},
  cablecurl:{primary:["biceps"],secondary:[]},
  tridip:{primary:["triceps"],secondary:[]},
  revbarbell:{primary:["biceps"],secondary:[]},
  bayesian:{primary:["biceps"],secondary:[]},
  kickback:{primary:["triceps"],secondary:[]},
  spidercurl:{primary:["biceps"],secondary:[]},
  // Core
  plank:{primary:["core"],secondary:[]},
  crunch:{primary:["core"],secondary:[]},
  hangleg:{primary:["core"],secondary:[]},
  cablecrunch:{primary:["core"],secondary:[]},
  russiantwist:{primary:["core"],secondary:[]},
  abwheel:{primary:["core"],secondary:[]},
  woodchop:{primary:["core"],secondary:[]},
  deadbug:{primary:["core"],secondary:[]},
  pallof:{primary:["core"],secondary:[]},
  decline_sit:{primary:["core"],secondary:[]},
  // New Chest
  cablecross:{primary:["chest"],secondary:[]},lowcableflye:{primary:["chest"],secondary:[]},
  svincbench:{primary:["chest"],secondary:["triceps","front_delts"]},dbpullover:{primary:["chest"],secondary:["back"]},
  diamondpush:{primary:["triceps"],secondary:["chest"]},widepush:{primary:["chest"],secondary:["triceps"]},
  floordbbench:{primary:["chest"],secondary:["triceps"]},machincpress:{primary:["chest"],secondary:["triceps"]},
  // New Back
  closegriplat:{primary:["back"],secondary:["biceps"]},widegriplat:{primary:["back"],secondary:["biceps"]},
  machrow:{primary:["back"],secondary:["biceps"]},chestrow:{primary:["back"],secondary:["biceps"]},
  sealrow:{primary:["back"],secondary:["biceps"]},singlearmcablerow:{primary:["back"],secondary:["biceps"]},
  reversegriprow:{primary:["back"],secondary:["biceps"]},invertedrow:{primary:["back"],secondary:["biceps"]},
  latprayer:{primary:["back"],secondary:[]},shrugs:{primary:["traps"],secondary:[]},rackpull:{primary:["back"],secondary:["hamstrings","glutes"]},
  // New Legs
  pendulumsguat:{primary:["quads"],secondary:["glutes"]},smithsquat:{primary:["quads"],secondary:["glutes"]},
  walkinglunge:{primary:["quads"],secondary:["glutes","hamstrings"]},reverselunge:{primary:["quads"],secondary:["glutes"]},
  seatcalf:{primary:["calves"],secondary:[]},legpresscalf:{primary:["calves"],secondary:[]},
  goodmorning:{primary:["hamstrings"],secondary:["back","glutes"]},nordiccurl:{primary:["hamstrings"],secondary:[]},
  glutebridge:{primary:["glutes"],secondary:["hamstrings"]},cablepullthrough:{primary:["glutes"],secondary:["hamstrings"]},
  lyinglegcurl:{primary:["hamstrings"],secondary:[]},boxsquat:{primary:["quads"],secondary:["glutes"]},
  singlelegpress:{primary:["quads"],secondary:["glutes"]},singlelegrdl:{primary:["hamstrings"],secondary:["glutes"]},
  hipabductor:{primary:["glutes"],secondary:[]},hipadductor:{primary:["quads"],secondary:[]},
  dbrdl:{primary:["hamstrings"],secondary:["glutes"]},pistolsquat:{primary:["quads"],secondary:["glutes","core"]},
  beltquat:{primary:["quads"],secondary:["glutes"]},
  // New Shoulders
  machlateral:{primary:["side_delts"],secondary:[]},machshoulder:{primary:["front_delts"],secondary:["triceps"]},
  svohp:{primary:["front_delts"],secondary:["triceps"]},cablereardelt:{primary:["rear_delts"],secondary:[]},
  reversefly:{primary:["rear_delts"],secondary:[]},behindneckpress:{primary:["front_delts","side_delts"],secondary:["triceps"]},
  dblateralraise:{primary:["side_delts"],secondary:[]},luyang:{primary:["front_delts","side_delts"],secondary:[]},
  zspress:{primary:["front_delts"],secondary:["triceps","core"]},handstandpush:{primary:["front_delts"],secondary:["triceps","core"]},
  // New Arms
  dbtricext:{primary:["triceps"],secondary:[]},inclinecurl:{primary:["biceps"],secondary:[]},
  ropeoverhead:{primary:["triceps"],secondary:[]},ropepush:{primary:["triceps"],secondary:[]},
  ezbar:{primary:["biceps"],secondary:[]},crossbodycurl:{primary:["biceps"],secondary:[]},
  machbicep:{primary:["biceps"],secondary:[]},machtricep:{primary:["triceps"],secondary:[]},
  wristcurl:{primary:["biceps"],secondary:[]},reversewrist:{primary:["biceps"],secondary:[]},
  "21s":{primary:["biceps"],secondary:[]},jmpress:{primary:["triceps"],secondary:["chest"]},
  dipbw:{primary:["triceps"],secondary:["chest","front_delts"]},waiter:{primary:["biceps"],secondary:[]},
  // New Core
  sideplank:{primary:["core"],secondary:[]},toetouches:{primary:["core"],secondary:[]},
  leglifts:{primary:["core"],secondary:[]},bicycle:{primary:["core"],secondary:[]},
  dragonfl:{primary:["core"],secondary:[]},reversecrunch:{primary:["core"],secondary:[]},
  // Olympic
  clean:{primary:["back","quads"],secondary:["glutes","hamstrings","traps","core"]},
  cleanjerk:{primary:["back","quads","front_delts"],secondary:["glutes","hamstrings","triceps","core"]},
  snatch:{primary:["back","quads"],secondary:["front_delts","core","glutes"]},
  hangclean:{primary:["back","traps"],secondary:["quads","glutes","core"]},
  powersnatch:{primary:["back","quads"],secondary:["front_delts","core"]},
  thruster:{primary:["quads","front_delts"],secondary:["glutes","triceps","core"]},
  cleanpull:{primary:["back","traps"],secondary:["hamstrings","glutes"]},
  pushjerk:{primary:["front_delts"],secondary:["triceps","quads","core"]},
  // Full Body
  farmwalk:{primary:["traps","core"],secondary:["glutes","quads"]},
  turkgetup:{primary:["core","front_delts"],secondary:["glutes","quads"]},
  sledpush:{primary:["quads","glutes"],secondary:["core","calves"]},
  sledpull:{primary:["back","hamstrings"],secondary:["glutes","core"]},
  sandbag:{primary:["core","traps"],secondary:["glutes","quads"]},
  wallball:{primary:["quads","front_delts"],secondary:["core","glutes"]},
  kettleswing:{primary:["glutes","hamstrings"],secondary:["core","back"]},
  kettleclean:{primary:["front_delts","back"],secondary:["core","glutes"]},
  manmaker:{primary:["chest","front_delts","quads"],secondary:["triceps","core","back"]},
  mtclimber:{primary:["core"],secondary:["quads","front_delts"]},
  // 2026 expansion — Chest
  paused_bench:{primary:["chest"],secondary:["triceps","front_delts"]},
  hexpress:{primary:["chest"],secondary:["triceps"]},
  inclineflye:{primary:["chest"],secondary:[]},
  deficitpush:{primary:["chest"],secondary:["triceps","front_delts"]},
  weightedpush:{primary:["chest"],secondary:["triceps","front_delts"]},
  // 2026 expansion — Back
  trapbar:{primary:["back","quads"],secondary:["glutes","hamstrings","traps"]},
  deficitdl:{primary:["back","hamstrings"],secondary:["glutes","core"]},
  cablepullover:{primary:["back"],secondary:["chest"]},
  kroc:{primary:["back"],secondary:["biceps","traps"]},
  gorillarow:{primary:["back"],secondary:["biceps","core"]},
  weightedpullup:{primary:["back"],secondary:["biceps","core"]},
  neutralpullup:{primary:["back"],secondary:["biceps"]},
  // 2026 expansion — Legs
  zerchersquat:{primary:["quads"],secondary:["glutes","core"]},
  sumosquat:{primary:["quads","glutes"],secondary:["hamstrings"]},
  curtsy:{primary:["glutes"],secondary:["quads"]},
  splitsquat:{primary:["quads"],secondary:["glutes"]},
  donkeycalf:{primary:["calves"],secondary:[]},
  tibraise:{primary:["calves"],secondary:[]},
  wallsit:{primary:["quads"],secondary:["glutes"]},
  // 2026 expansion — Shoulders
  seatedohp:{primary:["front_delts"],secondary:["triceps"]},
  pushpress:{primary:["front_delts"],secondary:["triceps","quads","core"]},
  pikepush:{primary:["front_delts"],secondary:["triceps","core"]},
  platefront:{primary:["front_delts"],secondary:[]},
  cubanpress:{primary:["rear_delts","side_delts"],secondary:["traps"]},
  // 2026 expansion — Arms
  dragcurl:{primary:["biceps"],secondary:[]},
  zottman:{primary:["biceps"],secondary:[]},
  cablehammer:{primary:["biceps"],secondary:[]},
  singletricep:{primary:["triceps"],secondary:[]},
  // 2026 expansion — Core
  vsit:{primary:["core"],secondary:[]},
  hollowhold:{primary:["core"],secondary:[]},
  birddog:{primary:["core"],secondary:["glutes"]},
  copenhagen:{primary:["core"],secondary:[]},
  suitcasecarry:{primary:["core"],secondary:["traps"]},
  weightedplank:{primary:["core"],secondary:[]},
  landminerotation:{primary:["core"],secondary:["front_delts"]},
  // 2026 expansion — Olympic
  splitjerk:{primary:["front_delts"],secondary:["triceps","quads","core"]},
  snatchpull:{primary:["back","traps"],secondary:["hamstrings","glutes"]},
  ohsquat:{primary:["quads"],secondary:["front_delts","core","glutes"]},
  // 2026 expansion — Full Body
  bearcrawl:{primary:["core"],secondary:["front_delts","quads"]},
  devilpress:{primary:["front_delts","quads"],secondary:["chest","core","glutes"]},
  tireflip:{primary:["back","quads"],secondary:["glutes","hamstrings","core"]},
  medballslam:{primary:["core"],secondary:["back","front_delts"]},
  // Machines
  smithfrontsq:{primary:["quads"],secondary:["glutes"]},
  cableflylow:{primary:["chest"],secondary:[]},cableflyhigh:{primary:["chest"],secondary:[]},
  legsled:{primary:["quads"],secondary:["glutes"]},machshrug:{primary:["traps"],secondary:[]},
  machcalf:{primary:["calves"],secondary:[]},reversehy:{primary:["back","glutes"],secondary:["hamstrings"]},
  glute_ham:{primary:["hamstrings","glutes"],secondary:["back"]},
  machlegpress45:{primary:["quads"],secondary:["glutes"]},smithrdl:{primary:["hamstrings"],secondary:["back","glutes"]},
  cablelateral2:{primary:["side_delts"],secondary:[]},pecdeck:{primary:["chest"],secondary:[]},
  machrear:{primary:["rear_delts"],secondary:[]},assistpullup:{primary:["back"],secondary:["biceps"]},
  legabduction:{primary:["glutes"],secondary:[]},
};

// All muscle groups for heat map
export const ALL_MUSCLES=["chest","back","front_delts","side_delts","rear_delts","traps","biceps","triceps","quads","hamstrings","glutes","calves","core"];
export const MUSCLE_LABELS={chest:"Chest",back:"Back",front_delts:"Front Delts",side_delts:"Side Delts",rear_delts:"Rear Delts",traps:"Traps",biceps:"Biceps",triceps:"Triceps",quads:"Quads",hamstrings:"Hamstrings",glutes:"Glutes",calves:"Calves",core:"Core"};

// ─── Progressive Overload Engine (Enhanced) ───

